import loadable from '@loadable/component';

const Modules = {
    richTextModule: loadable(() => import('./RichTextModule')),
    highlightedTextModule: loadable(() => import('./HighlightedTextModule')),
    callToActionModule: loadable(() => import('./CallToActionModule')),
    columnModule: loadable(() => import('./ColumnModule')),
    imageTextModule: loadable(() => import('./ImageTextModule')),
    stockStatusModule: loadable(() => import('./StockStatusModule')),
    highlightedContentModule: loadable(() => import('./HighlightedContentModule')),
    productSliderModule: loadable(() => import('./ProductSliderModule')),
    cookietractorInformationModule: loadable(() => import('./CookietractorInformationModule')),
    configuratorModule: loadable(() => import('./ConfiguratorModule')),
};

export default Modules;
